const getFlowSteps = (trees) => {
    return Object.values(trees).reduce((acc, tree) => {
        var _a, _b;
        return (_b = acc + ((_a = ((tree.steps || []).filter(step => step.type !== 'empty'))) === null || _a === void 0 ? void 0 : _a.length)) !== null && _b !== void 0 ? _b : 0;
    }, 0);
};
export function flowUpsertDataDto(flow) {
    const { description, label, trees, meta } = flow.data;
    const { id, botId, dateCreated, dateModified } = flow;
    return {
        id,
        botId,
        dateCreated,
        dateModified,
        description,
        label,
        flowSteps: getFlowSteps(trees),
        meta,
    };
}
export function flowActivateDataDto(flow) {
    const { meta: { idw: { skills = [] }, channel = undefined } } = flow.data;
    return {
        channel,
        skills,
    };
}
//# sourceMappingURL=flowUpsert.dto.js.map